import { render, staticRenderFns } from "./NormalSearchNav80.vue?vue&type=template&id=27f07464&scoped=true&"
import script from "./NormalSearchNav80.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav80.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f07464",
  null
  
)

export default component.exports